export function bfs(start,end,nodes,visitors,path,rows,cols,res){
		
    visitors=[];
    let finders=[];
    finders.push(start)
    while(finders.length!==0){

        let c=finders.shift();
        if(c[0]===end[0] && c[1]===end[1]){
            
            nodes[start[0]][start[1]].parentset=false;
            nodes[start[0]][start[1]].parent=null;
            let idx;
            
            for(let k=0;k<visitors.length;k++){
                if(visitors[k][0]===end[0] && visitors[k][1]===end[1]){
                    idx=k;
                    break;
                }
            }
            
            visitors=visitors.slice(0,idx+1);
            
            finders=[];
            break;
        }
        let neighbors=[
                        [c[0]-1,c[1]],
                        
                        [c[0],c[1]-1],
                        [c[0],c[1]+1],
                        [c[0]+1,c[1]]];
        for(let q=0;q<neighbors.length;q++){
            let k=neighbors[q]
            if(0<=k[0] && k[0]<rows && 0<=k[1] && k[1]<cols && nodes[k[0]][k[1]].visited===false && nodes[k[0]][k[1]].iswall===false){
                    finders.push([k[0],k[1]]);
                    visitors.push([k[0],k[1]]);
                    nodes[k[0]][k[1]].visited=true;
                    if(nodes[k[0]][k[1]].parentset===false){
                        nodes[k[0]][k[1]].parent=nodes[c[0]][c[1]];
                        nodes[k[0]][k[1]].parentset=true;
                    }
            
            }

        }

    }

    
    
    let k=nodes[end[0]][end[1]]
    
    while(k.parent){
        path.push([k.parent.x/res,k.parent.y/res]);
        
        
        k=k.parent;
    }
    return[nodes,visitors,path];
    
    

}


export function dfs(start,end,nodes,visitors,path,rows,cols,res){
    visitors=[];
    let finders=[];
    finders.push(start)
    while(finders.length!==0){

        let c=finders.pop();
        if(c[0]===end[0] && c[1]===end[1]){
            
            nodes[start[0]][start[1]].parentset=false;
            nodes[start[0]][start[1]].parent=null;
            let idx;
            
            for(let k=0;k<visitors.length;k++){
                if(visitors[k][0]===end[0] && visitors[k][1]===end[1]){
                    idx=k;
                    break;
                }
            }
            
            visitors=visitors.slice(0,idx+1);
            
            finders=[];
            break;
        }
        let neighbors=[[c[0]+1,c[1]],
                        [c[0]-1,c[1]],
                        
                        [c[0],c[1]-1],
                        [c[0],c[1]+1]];
        for(let q=0;q<neighbors.length;q++){
            let k=neighbors[q]
            if(0<=k[0] && k[0]<rows && 0<=k[1] && k[1]<cols && nodes[k[0]][k[1]].visited===false && nodes[k[0]][k[1]].iswall===false){
                    finders.push([k[0],k[1]]);
                    visitors.push([k[0],k[1]]);
                    nodes[k[0]][k[1]].visited=true;
                    if(nodes[k[0]][k[1]].parentset===false){
                        nodes[k[0]][k[1]].parent=nodes[c[0]][c[1]];
                        nodes[k[0]][k[1]].parentset=true;
                    }
            
            }

        }

    }

    
    
    let k=nodes[end[0]][end[1]]
    
    while(k.parent){
        path.push([k.parent.x/res,k.parent.y/res]);
        
        
        k=k.parent;
    }
    return[nodes,visitors,path];
    
    
    




}


export function astar(start,end,nodes,visitors,path,rows,cols,res){
    visitors=[];
    let finders=[];
    finders.push(start)
    while(finders.length!==0){

        let ridx=lowf(finders,nodes);
        let c=finders[ridx];
        finders.splice(ridx,1);
        if(c[0]===end[0] && c[1]===end[1]){
            
            nodes[start[0]][start[1]].parentset=false;
            nodes[start[0]][start[1]].parent=null;
            let idx;
            
            for(let k=0;k<visitors.length;k++){
                if(visitors[k][0]===end[0] && visitors[k][1]===end[1]){
                    idx=k;
                    break;
                }
            }
            
            visitors=visitors.slice(0,idx+1);
            
            finders=[];
            break;
        }
        let neighbors=[[c[0]+1,c[1]],
                        [c[0]-1,c[1]],
                        
                        [c[0],c[1]-1],
                        [c[0],c[1]+1]];
        for(let q=0;q<neighbors.length;q++){
            let k=neighbors[q]
            if(0<=k[0] && k[0]<rows && 0<=k[1] && k[1]<cols && nodes[k[0]][k[1]].visited===false && nodes[k[0]][k[1]].iswall===false){
                    
                    let current=nodes[c[0]][c[1]];
                    let neighbor=nodes[k[0]][k[1]];
                    let tempg=current.g+1;
                    if(finders.includes([k[0],k[1]])){
                        if(tempg<neighbor.g){
                            neighbor.g=tempg;
                        }
                    }
                    else{
                        neighbor.g=tempg;
                        finders.push([k[0],k[1]]); 
                        nodes[k[0]][k[1]].visited=true;
                        if(nodes[k[0]][k[1]].parentset===false){
                            nodes[k[0]][k[1]].parent=nodes[c[0]][c[1]];
                            nodes[k[0]][k[1]].parentset=true;
                        }   
                    }
                    neighbor.h=Math.abs(k[0]-end[0])+Math.abs(k[1]-end[1]);
                    neighbor.f=neighbor.g+neighbor.h;
                
                    
                    visitors.push([k[0],k[1]]);
                    
                    
            
            }

        }

    }

    
    
    let k=nodes[end[0]][end[1]]
    
    while(k.parent){
        path.push([k.parent.x/res,k.parent.y/res]);
        
        
        k=k.parent;
    }
    return[nodes,visitors,path];
    
    
    




}


const lowf=(finders,nodes)=>{
    let idx=0
    for(let i=0;i<finders.length;i++){
        let x=finders[i][0],y=finders[i][1];
        let ci=finders[idx][0],cj=finders[idx][1];
        if(nodes[x][y].f < nodes[ci][cj].f){
            idx=i;
        }
    }
    return idx;

}






export function dijkstra(start,end,nodes,visitors,path,rows,cols,res){
    visitors=[];
    let finders=[];
    finders.push(start)
    while(finders.length!==0){

        let ridx=lowd(finders,nodes);
        let c=finders[ridx];
        finders.splice(ridx,1);
        if(c[0]===end[0] && c[1]===end[1]){
            
            nodes[start[0]][start[1]].parentset=false;
            nodes[start[0]][start[1]].parent=null;
            let idx;
            
            for(let k=0;k<visitors.length;k++){
                if(visitors[k][0]===end[0] && visitors[k][1]===end[1]){
                    idx=k;
                    break;
                }
            }
            
            visitors=visitors.slice(0,idx+1);
            
            finders=[];
            break;
        }
        let neighbors=[[c[0]+1,c[1]],
                        [c[0]-1,c[1]],
                        
                        [c[0],c[1]-1],
                        [c[0],c[1]+1]];
        for(let q=0;q<neighbors.length;q++){
            let k=neighbors[q]
            if(0<=k[0] && k[0]<rows && 0<=k[1] && k[1]<cols && nodes[k[0]][k[1]].visited===false && nodes[k[0]][k[1]].iswall===false){
                    
                    let current=nodes[c[0]][c[1]];
                    let neighbor=nodes[k[0]][k[1]];
                    let tempd=current.d+1;
                    if(finders.includes([k[0],k[1]])){
                        if(tempd<neighbor.d){
                            neighbor.d=tempd;
                        }
                    }
                    else{
                        neighbor.d=tempd;
                        finders.push([k[0],k[1]]); 
                        nodes[k[0]][k[1]].visited=true;
                        if(nodes[k[0]][k[1]].parentset===false){
                            nodes[k[0]][k[1]].parent=nodes[c[0]][c[1]];
                            nodes[k[0]][k[1]].parentset=true;
                        }   
                    }
                    
                
                    
                    visitors.push([k[0],k[1]]);
                    
                    
            
            }

        }

    }

    
    
    let k=nodes[end[0]][end[1]]
    
    while(k.parent){
        path.push([k.parent.x/res,k.parent.y/res]);
        
        
        k=k.parent;
    }
    return[nodes,visitors,path];
    
    
    




}


const lowd=(finders,nodes)=>{
    let idx=0
    for(let i=0;i<finders.length;i++){
        let x=finders[i][0],y=finders[i][1];
        let ci=finders[idx][0],cj=finders[idx][1];
        if(nodes[x][y].d < nodes[ci][cj].d){
            idx=i;
        }
    }
    return idx;

}